module.exports = __webpack_public_path__ + "img/tubiao.0352daa0.png";